import { Injectable } from "@angular/core";
import { environment } from "@edp-environments/environment";
import { AppService } from "@edp-services/app.service";
import { EnvService } from "@edp-services/env.service";
import { ShowIframeModal } from "@edp-store/actions/iframe.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";

@Injectable({
    providedIn: "root",
})
export class ExternalLinkService {
    constructor(private readonly store: Store<IAppState>, private readonly appService: AppService, private envService: EnvService) {}

    public externalLink(edpExternalLink: string, isFile?: boolean) {
        const hasExternalLinkParam = edpExternalLink.indexOf("#EXTERNAL_LINK") !== -1;
        const isApp = environment.isApp;
        const hasEDPDomain =
            edpExternalLink.indexOf(this.envService.getDomain()) !== -1 ||
            edpExternalLink.indexOf("edp.com") !== -1 ||
            edpExternalLink.indexOf("edpenergia.es") !== -1;
        const isOwnDomain = edpExternalLink.indexOf(this.envService.appUrl()) !== -1;

        if (isApp && !isOwnDomain) {
            if (edpExternalLink.indexOf(this.envService.appUrl()) !== -1) {
                edpExternalLink = edpExternalLink.replace(this.envService.appUrl(), environment.appUrlV1);
            }
            if (hasExternalLinkParam) {
                this.appService.openExternalLink(edpExternalLink);
                return;
            }
            if (hasEDPDomain) {
                this.store.dispatch(new ShowIframeModal({ url: edpExternalLink, isFile }));
                return;
            }
            this.appService.openExternalLink(edpExternalLink);
            return;
        } else if (isApp && hasEDPDomain) {
            this.store.dispatch(new ShowIframeModal({ url: edpExternalLink, isFile }));
            return;
        }

        this.store.dispatch(new ShowIframeModal(null));
        if (isOwnDomain) {
            window.location.href = edpExternalLink;
        } else {
            window.open(edpExternalLink, "_blank");
        }
    }
}
